import React from "react";
import { Navigate, Outlet } from "react-router-dom";
const AuthRoute = (props) => {
  let user = JSON.parse(localStorage.getItem("user"));
  return user?.tokens?.access?.token ? <Outlet /> : <Navigate to="/login" />;
};

export default AuthRoute;
